import { render, staticRenderFns } from "./AllTrips.vue?vue&type=template&id=bc2e4a6a"
import script from "./AllTrips.vue?vue&type=script&lang=js"
export * from "./AllTrips.vue?vue&type=script&lang=js"
import style0 from "./AllTrips.vue?vue&type=style&index=0&id=bc2e4a6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports